/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout';
var schooldoctorRouter = [
  // {
  //   path: '/school/file',
  //   component: Layout,
  //   meta: { roles: ['schooldoctor'] },
  //   children: [
  //     {
  //       path: '',
  //       name: 'file',
  //       component: () => import('@/views/school/file'),
  //       meta: { title: '学生档案管理', icon: 'ope' },
  //     }
  //   ]
  // },
  // {
  //   path: '/school/screencompany',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'screencompany',
  //       component: () => import('@/views/school/screencompany'),
  //       meta: { title: '筛查单位信息', icon: 'company', roles: ['schooldoctor'] },
  //     }
  //   ]
  // },

  // {
  //   path: '/school/roport',
  //   name: 'roport',
  //   component: Layout,
  //   meta: { title: '数据分析', icon: 'report', roles: ['schooldoctor'] },
  //   children: [
  //     {
  //       path: 'school',
  //       component: () => import('@/views/school/report/school'),
  //       meta: { title: '全校数据分析' }
  //     },
  //     {
  //       path: 'grade',
  //       component: () => import('@/views/school/report/grade'),
  //       meta: { title: '年级数据分析' }
  //     },
  //     {
  //       path: 'class',
  //       component: () => import('@/views/school/report/class'),
  //       meta: { title: '班级数据分析' }
  //     }
  //   ]
  // },
  // {
  //   path: '/school/personal',
  //   component: Layout,
  //   meta: { roles: ['schooldoctor'] },
  //   children: [
  //     {
  //       path: '',
  //       name: 'personal',
  //       component: () => import('@/views/gov/personal'),
  //       meta: { title: '个案数据分析', icon: 'people' },
  //     }
  //   ]
  // },
];
export default schooldoctorRouter;